export const zhTW = {
  "footer": {
    "sharedTitle": "覺光常在",
    "contactHeading": "CONTACT & INFO",
    "copyright": "Copyright © 2026 Chung Tai Chan Monastery",
    "address": "地址: 545南投縣埔里鎮一新里中台路2號",
    "phoneFax": "電話: 049-2930215・傳真: 049-2930332",
    "accountName": "戶名: 財團法人中台山佛教基金會",
    "email": "Email: ctworld@mail.ctcm.org.tw",
    "version": "Version: {{version}}",
    "monasteryEn": "CHUNG TAI CHAN MONASTERY",
    "anniversaryEn": "35TH ANNIVERSARY"
  },
  "nav": {
    "dna": "護法DNA",
    "lampBlessing": "點燈祈福",
    "quiz": "中台知多少？",
    "postcard": "寄送明信片",
    "liveComment": "禪心連線",
    "jueGuang": "庭影覺光",
    "wishTree": "願心樹",
    "anniversary": "中台山 35 週年慶",
    "wisdomLamp": "文星點燈",
    "transmission": "中台心傳",
    "guardianExpo": "護法薪傳",
    "interactiveSection": "互動專區",
    "dnaShort": "護法DNA",
    "lampBlessingShort": "點燈祈福",
    "quizShort": "中台知多少？",
    "postcardShort": "寄送明信片",
    "liveCommentShort": "禪心連線",
    "jueGuangShort": "庭影覺光",
    "wishTreeShort": "願心樹",
    "goToWishTree": "前往願心樹 ⮕"
  },
  "header": {
    "logoAlt": "中台山",
    "returnHomeTitle": "返回首頁",
    "guest": "訪客",
    "loggedIn": "已登入",
    "profile": "個人資訊",
    "showQrCode": "顯示條碼",
    "login": "登入",
    "register": "註冊",
    "logout": "登出",
    "logoutSuccess": "登出成功",
    "menuTitle": "選單",
    "copiedToClipboard": "已複製到剪貼簿: \n{{text}}",
    "copyFailed": "複製失敗: {{error}}"
  },
  "home": {
    "newsGoToBranchReport": "前往精舍報導",
    "splashAlt": "Splash",
    "newsTitleLine1": "最新",
    "newsTitleLine2": "消息",
    "newsEmpty": "敬請期待",
    "showMore": "顯示更多",
    "viewMore": "查看更多",
    "videosTitleLine2": "影音",
    "interactiveTitleLine1": "互動",
    "interactiveTitleLine2": "專區",
    "newsGoTo": "前往",
    "videoViews": "{{count}} 次觀看"
  },
  "banner": {
    "registerNow": "立即註冊"
  },
  "bottomNav": {
    "home": "回首頁",
    "videos": "影片集",
    "redeem": "兌換",
    "scan": "掃碼"
  },
  "login": {
    "heroTitle": "覺光常在",
    "heroSubtitle": "中台開山三十五週年紀念活動",
    "submit": "登入",
    "submitting": "登入中...",
    "successToast": "登入成功",
    "failureToast": "登入失敗：{{message}}"
  },
  "auth": {
    "monasteryLabel": "所屬精舍",
    "selectPlaceholder": "請選擇",
    "noResults": "查無結果",
    "nameLabel": "姓名",
    "dharmaNameLabel": "法名",
    "birthdayLabel": "生日",
    "inputPlaceholder": "請輸入",
    "birthdayPlaceholder": "請輸入 (月月日日 / 例 0311)",
    "showBirthday": "顯示生日",
    "hideBirthday": "隱藏生日",
    "register": "註冊",
    "requiredFieldsAlert": "請填寫必填欄位",
    "birthdayFormatAlert": "生日格式錯誤，請輸入4碼數字 (例如 0608)",
    "checkInput": "請檢查輸入資料",
    "successTitle": "註冊成功"
  },
  "register": {
    "mascotGoldChild": "金頂童子",
    "mascotElephant": "六牙白象",
    "mascotLion": "白獅",
    "mascotDeer": "白鹿",
    "defaultEncouragement": "歡迎一同慶讚中台開山三十五週年！",
    "titleMember": "會員",
    "mascotLabel": "選擇吉祥物",
    "cancel": "取消",
    "submitting": "註冊中...",
    "failureToast": "註冊失敗：{{message}}",
    "enterHome": "進入首頁"
  },
  "redeem": {
    "mascotYAxisWalk": "行",
    "mascotYAxisStay": "住",
    "mascotYAxisSit": "坐",
    "mascotYAxisRest": "臥",
    "mascotYAxisPosture": "威儀",
    "mascotXAxisGoldChild": "金頂童子",
    "mascotXAxisElephant": "六牙白象",
    "mascotXAxisLion": "白獅",
    "mascotXAxisDeer": "白鹿",
    "pageTitle": "積分兌換",
    "viewRulesAria": "查看詳細規則",
    "sectionMascot": "吉祥物",
    "sectionVoucher": "兌換券",
    "loading": "載入中...",
    "noMascotRecords": "尚無吉祥物紀錄",
    "noVoucherRecords": "尚無兌換券紀錄",
    "redeeming": "兌換中",
    "redeem": "兌換",
    "addedToBag": "已加入百寶箱中",
    "redeemFailed": "兌換失敗，請稍後再試",
    "closeAria": "關閉",
    "goBackAria": "返回上一頁",
    "mascot": "吉祥物",
    "alreadyOwned": "已擁有",
    "viewTreasureBag": "查看百寶箱",
    "redeemPoints": "兌換點數",
    "useVoucher": "兌換券兌換",
    "insufficientVoucher": "兌換券不足",
    "insufficientPoints": "點數不足",
    "redeemWithPoints": "點數兌換",
    "cancel": "取消",
    "confirm": "確認",
    "redeemSuccess": "兌換成功",
    "noRedeemableMascot": "沒有可兌換的吉祥物",
    "insufficientForRedeem": "兌換券或點數不足兌換",
    "selectRedeemMethod": "請選擇兌換方式",
    "useOneVoucher": "使用1張兌換券換【",
    "pointsForRedeem": "點兌換【",
    "notFoundMascot": "查無此吉祥物",
    "scoreBarLabel": "積分（可用積分/總積分）"
  },
  "profile": {
    "blessingHealth": "身體健康",
    "blessingFamily": "家庭和樂",
    "blessingDharma": "道業成就",
    "blessingStudy": "學業進步",
    "blessingCareer": "事業順利",
    "blessingConnection": "廣結善緣",
    "mascotYAxisWalk": "行",
    "mascotYAxisStay": "住",
    "mascotYAxisSit": "坐",
    "mascotYAxisRest": "臥",
    "sectionZenHeart": "禪心連線",
    "sectionBlessingLamp": "點燈祈福",
    "sectionDharmaDNA": "護法DNA",
    "sectionChungTai": "中台知多少",
    "sectionPostcard": "寄送明信片",
    "sectionWishTree": "願心樹",
    "tabTreasureBag": "百寶袋",
    "sectionWisdomLamp": "文星點燈",
    "sectionTransmission": "中台心傳",
    "noTransmissionRecords": "尚無應援紀錄",
    "mascotYAxisPosture": "威儀",
    "mascotXAxisGoldChild": "金頂童子",
    "mascotXAxisElephant": "六牙白象",
    "mascotXAxisLion": "白獅",
    "mascotXAxisDeer": "白鹿",
    "sectionDharmaTeaching": "獲得法語",
    "loading": "載入中...",
    "tabAboutMe": "關於我",
    "tabActivityPoints": "活動積分",
    "scoreLabel": "積分（可用積分/總積分）",
    "nameLabel": "姓名",
    "birthdayLabel": "生日",
    "dharmaNameLabel": "法名",
    "monasteryLabel": "所屬精舍",
    "registeredAtLabel": "註冊日期",
    "emptyValue": "無",
    "noRecord": "無紀錄",
    "viewRulesAria": "查看詳細規則",
    "expandAll": "查看全部 {{count}} 筆",
    "collapse": "收起",
    "sectionPhysical": "實體互動",
    "noCheckInRecords": "尚無打卡紀錄",
    "sectionPoints": "積分互送",
    "noGiftRecords": "尚無紀錄",
    "noConnectionRecords": "尚無連線紀錄",
    "noSupportRecords": "尚無應援紀錄",
    "sectionMascot": "吉祥物",
    "noQuizRecords": "尚無測驗紀錄",
    "chipEventTime": "活動時間",
    "chipEventLocation": "活動地點",
    "chipCheckInTime": "打卡時間",
    "chipDharmaOrName": "法名/姓名",
    "chipTime": "時間",
    "avatarInitialFallback": "人",
    "goToRedeemMascot": "前往兌換吉祥物",
    "postcardSentCount": "累積寄送 {{count}} 次",
    "wishTreeVowCount": "至心發願 {{count}} 次",
    "vowRowAllCollected": "🎉 恭喜集滿，額外獲得+{{point}}積分",
    "mascotSwipeHint": "左右滑動查看",
    "mascotSetAvatar": "設為頭像",
    "sectionSpecialReward": "特別獎勵",
    "physicalGiftRedeemed": "已兌換",
    "specialRewardStage1Title": "5000分實體禮物兌換",
    "specialRewardStage2Title": "10000分實體禮物兌換",
    "specialRewardStage3Title": "15000分實體禮物兌換",
    "specialRewardStage4Title": "20000分實體禮物兌換",
    "specialRewardStage1Points": "累積達5000分",
    "specialRewardStage2Points": "累積達10000分",
    "specialRewardStage3Points": "累積達15000分",
    "specialRewardStage4Points": "累積達20000分",
    "specialRewardStage1Task": "參加過精舍傳燈法會",
    "specialRewardStage2Task": "參加過精舍聯展活動",
    "specialRewardStage3Task": "參加過精舍聯展活動",
    "specialRewardStage4Task": "參加過精舍聯展活動",
    "closeAria": "關閉",
    "physicalGiftQrAlt": "兌換 QR Code",
    "physicalGiftQrDesc": "請出示此 QR Code 供現場人員掃描兌換",
    "physicalGiftQrFailed": "取得兌換碼失敗，請稍後再試",
    "physicalGiftExchangeSuccess": "兌換成功",
    "physicalGiftRecordCode": "兌換碼：{{code}}",
    "physicalGiftValidTime": "有效時間：{{time}}",
    "physicalGiftQrExpired": "QR Code 已過期",
    "physicalGiftRegenerateQr": "重新產生 QR Code"
  },
  "wisdom-lamp": {
    "introDefault": "斗星高照，機悟心緣，文星點燈，轉照大千。開山祖師於海內外各地廣設精舍，以一燈燃百千燈，燈燈相傳，光光相照。值此開山三十五週年之際，將由住持和尚為各精舍住持法師傳燈，凝聚海內外四眾弟子，以菩薩行願，點亮自性心燈，燃燈無盡，念報師恩。",
    "jumpToCurrentWeek": "前往本週傳燈時刻",
    "mediaTitleBlack": "傳燈",
    "routeMapTitleRed": "路線圖",
    "routeMapTagline": "燈燈相傳，心光熠熠。",
    "mapPreviewAlt": "路線圖預覽",
    "scheduleTitleRed": "傳燈時程表",
    "comingSoon": "敬請期待",
    "mediaTitleRed": "影音報導",
    "viewMore": "查看更多",
    "scheduleTitleBlack": "各精舍",
    "tabByTime": "依時間",
    "tabByRegion": "依區域",
    "monthSuffix": "月",
    "collapse": "收合",
    "expandAll": "展開全部 ({{count}})",
    "highlightsTitleBlack": "活動",
    "highlightsTitleRed": "花絮",
    "openMapHint": "點擊開啟地圖",
    "goToReport": "前往報導",
    "goToMonastery": "前往精舍"
  },
  "video-collection": {
    "pageTitle": "影片集",
    "latestTitleBlack": "首頁",
    "latestTitleRed": "影音",
    "lightingTitleBlack": "文星點燈",
    "lightingTitleRed": "傳燈影音",
    "wisdomScenesTitleBlack": "文星點燈",
    "wisdomScenesTitleRed": "精舍花絮",
    "jointExhibitionTitleBlack": "中台心傳",
    "jointExhibitionTitleRed": "聯展影片",
    "transmissionScenesTitleBlack": "中台心傳",
    "transmissionScenesTitleRed": "精舍影音",
    "viewMore": "查看更多",
    "collapse": "收合",
    "goToReport": "前往報導"
  },
  "quiz": {
    "heroTitle": "中台知多少",
    "gameRulesTitle": "遊戲說明",
    "rule1": "本遊戲為單選題，一經選定即無法變更。",
    "rule2": "積分獎勵僅限於「當週進度」且為「首次作答」時發放。",
    "rule3": "計分方式：單題答對獲得 10 積分；單一章節全數答對者，另享 50 積分獎勵。",
    "rule4": "章節題目於過後仍可再次挑戰，惟不重複計分。",
    "chapterPrevAria": "上一週",
    "chapterNextAria": "下一週",
    "comingSoon": "敬請期待",
    "startGame": "遊戲開始",
    "processing": "處理中...",
    "loading": "載入中…"
  },
  "quiz-answer": {
    "correctCountLabel": "答對題數",
    "pointsEarnedLabel": "此次獲得積分",
    "pointsUnit": "分",
    "homeAria": "回首頁"
  },
  "quiz-question": {
    "loadError": "讀取題目失敗，請稍後再試。",
    "noQuestions": "目前沒有題目。",
    "progress": "第 {{current}} 題 / 共 {{total}} 題",
    "correctTitle": "答對了！",
    "wrongTitle": "答錯了！",
    "correctAnswerPrefix": "正確答案是：",
    "nextAria": "下一題"
  },
  "qr-code": {
    "heroTitle": "QR Code活動簽到",
    "notLoggedIn": "未登入",
    "formatOk": "格式正確",
    "formatError": "格式錯誤",
    "checkinSuccess": "簽到成功",
    "checkinFailed": "簽到失敗",
    "checkinErrorRescan": "簽到錯誤，請重新掃描",
    "cameraNotReady": "鏡頭元件未就緒",
    "noCamera": "此裝置沒有可用相機",
    "chromeCameraPermission": "請允許 Chrome 使用相機後重試",
    "cameraOpenFailed": "無法開啟鏡頭，請確認權限",
    "copiedCode": "已複製條碼內容",
    "copyFailed": "複製失敗，請長按條碼手動複製",
    "activityCheckin": "活動簽到",
    "photoQrFailed": "無法從相片辨識 QR",
    "checkingIn": "簽到中…",
    "statusCheckingIn": "狀態：簽到中…",
    "scanHint": "掃描行動條碼，輕鬆完成活動簽到或互轉積分",
    "permissionHint": "請到系統設定開啟相機權限後返回本頁，或改用「顯示行動條碼」",
    "barcodeError": "條碼有誤，請重新刷新條碼再使用",
    "manualInputHint": "請輸入與掃描相同的條碼內容後按「確認」",
    "autoSubmitHint": "掃描成功後將自動送出；亦可點「顯示行動條碼」出示個人條碼",
    "cameraAria": "掃描鏡頭",
    "closeAria": "關閉",
    "alignQrHint": "請對準活動QR碼",
    "showQrAria": "顯示行動條碼",
    "accountLabel": "帳號：",
    "barcodePlaceholder": "請貼上或輸入條碼（E 或 U 開頭，共 11 碼）",
    "confirm": "確認",
    "scanMobileBarcode": "掃描行動條碼",
    "mobileQrAria": "行動條碼",
    "personalQrAlt": "個人行動條碼",
    "validTime": "有效時間:",
    "qrLoading": "載入中…",
    "qrLoadFailed": "讀取失敗，請稍後再試",
    "generatingQr": "產生條碼中…",
    "showQrDesc": "顯示行動條碼，供掃描以完成簽到或互轉積分。",
    "save": "儲存",
    "showQrAgain": "重新顯示條碼",
    "done": "完成",
    "refreshQr": "更新條碼",
    "checkinResultAria": "簽到結果",
    "rescanHint": "若要再次簽到請點「重新掃描」；完成後可返回首頁",
    "rescan": "重新掃描",
    "backHome": "回首頁"
  },
  "card": {
    "shareTitleDefault": "中台山35週年祝福明信片",
    "shareTitle": "{{from}} 送給 {{to}} 的祝福明信片 — 中台山35週年",
    "ctaTitle": "也想送出祝福嗎？",
    "ctaDesc": "為親友製作一張專屬的 35 週年祝福明信片",
    "loading": "載入明信片中…",
    "loadErrorTitle": "載入失敗",
    "loadErrorDesc": "網路或伺服器發生問題，請稍後再試",
    "reload": "重新載入",
    "notFoundTitle": "找不到這張明信片",
    "notFoundDesc": "連結可能已失效或輸入錯誤",
    "close": "關閉",
    "blessingFrom": "來自 {{name}} 的祝福",
    "blessingTo": "送給 {{name}}",
    "done": "完成",
    "makePostcard": "製作明信片",
    "shareModalTitle": "分享這張明信片",
    "copyLinkLabel": "複製連結",
    "copied": "已複製",
    "copy": "複製",
    "copyFailHint": "自動複製失敗，請長按上方連結手動複製",
    "shareLineAria": "分享到 LINE"
  },
  "postcard": {
    "stepSelectDesign": "選擇圖案",
    "stepFillContent": "填寫內容",
    "share": "分享",
    "toNamePlaceholder": "收件者姓名",
    "contentPlaceholder": "在此寫下您的祝福⋯",
    "fromNamePlaceholder": "您的姓名",
    "postcardAlt": "明信片"
  },
  "postcard-create": {
    "itemsLoadError": "載入圖案失敗，請重新整理",
    "requiredFields": "請填寫寄件人、收件人與祝福內容",
    "selectDesignFirst": "請先選擇明信片圖案",
    "createFailed": "建立失敗，請再試一次",
    "prevStep": "← 上一步",
    "creating": "建立中…"
  },
  "postcard-my": {
    "pageTitle": "我的明信片",
    "totalCount": "共 {{count}} 張",
    "add": "新增",
    "loading": "載入中…",
    "emptyTitle": "還沒有明信片",
    "emptyHint": "製作一張，送給重要的人吧",
    "createFirst": "製作第一張明信片",
    "toLabel": "To"
  },
  "branch-reports": {
    "notFoundRedirect": "{{count}} 秒後自動導向文星點燈頁面...",
    "noContent": "此精舍暫無報導內容",
    "loading": "載入中...",
    "notFoundTitle": "查無此頁面",
    "backAria": "返回上一頁",
    "likeAria": "按讚",
    "featuredTitle": "本週焦點精舍",
    "sectionTitle": "精舍供燈活動報導",
    "viewReport": "查看報導",
    "monasteryCount": "{{count}} 處"
  },
  "live-comment": {
    "heroTitle": "禪心連線",
    "notLoggedInDesc": "請先登入或註冊，即可參與禪心連線留言",
    "heroSubtitle": "選擇留言板進入場次",
    "notLoggedInTitle": "尚未登入",
    "loginRegister": "登入 / 註冊",
    "comingSoon": "敬請期待",
    "selectSession": "選擇活動場次",
    "backAria": "返回"
  },
  "live-comment-topic": {
    "hotPopupTitle": "隨喜讚嘆發燒留言",
    "backToSessions": "返回場次列表",
    "hotCommentsAria": "發燒留言",
    "reloadAria": "重新載入",
    "sortLatest": "最新",
    "sortMostLiked": "讚數最多",
    "refreshAdded": "新增 {{count}} 則留言",
    "refreshNone": "目前沒有新留言",
    "submittedPending": "留言已送出，審核通過後將顯示於留言板",
    "duplicateError": "您已留過相同的留言內容，請更換內容後再送出",
    "submitFailed": "留言失敗，請稍後再試",
    "boardPaused": "此留言板目前暫停留言",
    "boardEnded": "此留言板已結束，感謝您的參與",
    "placeholder": "留下您的祝福…",
    "submit": "送出",
    "loginToComment": "登入後才能留言",
    "goLogin": "前往登入",
    "likeAria": "按讚",
    "hotEmpty": "目前尚無發燒留言",
    "emptyTitle": "尚無留言",
    "emptyHint": "成為第一位留下祝福的人",
    "newComments": "{{count}} 則新留言"
  },
  "lamp-lighting": {
    "blessingHealth": "身體健康",
    "blessingFamily": "家庭和樂",
    "blessingDharma": "道業成就",
    "blessingStudy": "學業進步",
    "blessingCareer": "事業順利",
    "blessingConnection": "廣結善緣",
    "blessingHealthDesc": "身心安康 福壽增長",
    "blessingFamilyDesc": "和諧美滿 子孫賢孝",
    "blessingDharmaDesc": "福慧雙修 圓成佛道",
    "blessingStudyDesc": "金榜題名 智慧無礙",
    "blessingCareerDesc": "事事圓滿 所求皆應",
    "blessingConnectionDesc": "人緣和合 廣修善法",
    "heroDescription": "燃起佛前燈，滅除心頭火\n願以大智慧，照破眾無明",
    "blessingLabel": "發願回向",
    "blessingRequired": "請選擇發願回向",
    "heroTitle": "線上祈福點燈",
    "namePlaceholder": "請輸入祈福對象名稱",
    "submit": "送出祈福",
    "closeAria": "關閉",
    "nameLabel": "姓名",
    "nameRequired": "請輸入姓名",
    "monasteryLabel": "精舍別",
    "submitting": "送出中...",
    "skipProcessing": "處理中...",
    "skip": "跳過",
    "operationFailed": "操作失敗：{{message}}",
    "tryAgainLater": "請稍後再試",
    "monasteryRequired": "請選擇精舍"
  },
  "lamp-bulletin": {
    "pageTitle": "光照大千",
    "quoteText": "譬如一燈，燃百千燈\n冥者皆明，明終不盡",
    "quoteDedication": "願以此點燈功德  回向法界眾生",
    "offering": "供養",
    "totalLampsPrefix": "現在已點燈總數：",
    "filterOnlyMine": "只看我的點燈",
    "lightLampCta": "我要點燈",
    "errorNotFound": "找不到此祈願記錄",
    "errorInvalidId": "無效的祈願記錄編號",
    "errorLoadFailed": "無法載入祈願內容，請稍後再試",
    "lampUnit": "盞",
    "unmuteAria": "開啟音樂",
    "muteAria": "靜音",
    "datePlaceholder": "請輸入查詢日期",
    "namePlaceholder": "請輸入查詢姓名",
    "cancel": "取消",
    "selectDate": "選擇日期",
    "confirm": "確定",
    "yearSuffix": "年",
    "monthSuffix": "月",
    "daySuffix": "日",
    "bgLampAlt": "背景燈籠",
    "lampAlt": "燈籠",
    "errorNotYours": "該點燈不是您的 請搜尋或找尋您的點燈",
    "errorNetwork": "網路連線異常，請檢查您的網路連線",
    "errorTimeout": "請求逾時，請稍後再試"
  },
  "lamp": {
    "monasteryPlaceholder": "請選擇精舍"
  },
  "dna": {
    "rule1": "三十五年來，感恩十方菩薩的發心守護。護持道場，就是護持正法！從日常直覺，映照你出心中的「護法特質」。你是溫暖的陽、堅定的石、柔軟的川、安定的地，還是自在的雲？",
    "rule2": "只要 2 分鐘，憑直覺走入 10 個生活小劇場，解碼你的「護法 DNA」！"
  },
  "dna-answer": {
    "imageAlt": "護法 DNA",
    "calculating": "計算結果中…",
    "missingRecord": "缺少作答紀錄",
    "enterFromFlow": "請從測驗流程進入此頁，或返回重新作答。",
    "fetchError": "無法取得結果，請稍後再試。",
    "backToQuiz": "返回測驗",
    "imageNotFound": "找不到「{{name}}」對應圖片，請稍後再試。"
  },
  "dna-question": {
    "title": "尋找您的護法DNA",
    "progressLabel": "測驗進度",
    "quizEyebrow": "心理測驗",
    "loadingQuestions": "載入題目中…",
    "loadError": "無法載入題目，請稍後再試。",
    "reload": "重新載入",
    "noQuestions": "目前沒有題目。"
  },
  "jue-guang": {
    "pageTitle": "庭影覺光",
    "statusUpcoming": "即將開始",
    "statusActive": "上線中",
    "statusEnded": "已結束",
    "comingSoon": "敬請期待",
    "loading": "載入中..."
  },
  "jue-guang-topic": {
    "membersOnlyDesc": "登入後即可上傳分享你的心得",
    "onlyMyPosts": "只看我的文章",
    "namePlaceholder": "請輸入查詢姓名",
    "membersOnlyTitle": "僅限會員參與",
    "loginRegister": "登入 / 註冊",
    "noData": "查無資料",
    "loadMore": "載入更多",
    "selectDisplayName": "請選擇顯示名稱",
    "fillContent": "請填寫分享內容",
    "shareSuccessPending": "分享成功，等待審核後顯示",
    "shareFailed": "送出失敗，請稍後再試",
    "sharePlaceholder": "和我們分享...",
    "submitting": "送出中…",
    "publish": "發布",
    "landingMembersOnlyDesc": "登入後即可參與庭影覺光",
    "clickToUpload": "點擊上傳",
    "photoAlbum": "相簿",
    "takePhoto": "拍照",
    "recordVideo": "錄影",
    "durationError": "影片長度不可超過 30 秒，請重新選擇"
  },
  "jue-guang-record": {
    "notFound": "找不到此記錄",
    "back": "返回"
  },
  "transmission": {
    "pageTitle": "中台心傳",
    "introPlaceholder": "(介紹文字，待補)",
    "exhibitionInfoTitleBlack": "展場",
    "exhibitionInfoTitleRed": "地圖",
    "monasteryTransmissionTitleBlack": "各精舍",
    "monasteryTransmissionTitleRed": "聯展列表",
    "monasteryListPublishedDesc": "各精舍袖珍模型聯展將於 {{date}} 開放，敬請期待！",
    "groupByRegion": "依地區",
    "groupByArea": "依展區",
    "jointExhibitionTitleBlack": "聯展",
    "jointExhibitionTitleRed": "影片",
    "highlightsTitleBlack": "精舍",
    "highlightsTitleRed": "影片",
    "goToMonastery": "前往精舍",
    "wishTreeTitleBlack": "願心樹",
    "wishTreeTitleRed": "發願",
    "zoneFa": "法",
    "zoneShui": "水",
    "zoneChang": "長",
    "zoneLiu": "流",
    "tableDescPlaceholder": "內容待補",
    "goToReport": "前往報導"
  },
  "guardianExpo": {
    "pageTitle": "護法薪傳",
    "introSubtitle": "護法會博覽會",
    "introContent": "願承祖師大悲願， 化作禪心菩薩行。 護法薪傳，見賢思齊， 和合精進，用報深恩。 令佛眼不斷，正法永住！",
    "comingSoonDesc": "此展區內容尚在建置中，敬請期待！",
    "back": "返回",
    "relatedActivitiesTitleBlack": "相關",
    "relatedActivitiesTitleRed": "活動",
    "activityVideosTitleBlack": "活動",
    "activityVideosTitleRed": "影音",
    "activityVideosEmpty": "敬請期待",
    "lecture": {
      "title": "講座",
      "subtitle": "(副標題，待補)",
      "pageTitle": "講座展區",
      "introContent": "遠見召喚我們行動。九場專題講座，帶領我們思考如何走向更好的未來！",
      "cardDesc": "遠見召喚我們行動。九場專題講座，帶領我們思考如何走向更好的未來！",
      "scheduleTitleBlack": "講座",
      "scheduleTitleRed": "時程表",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    },
    "market": {
      "title": "技能交換市集",
      "subtitle": "(副標題，待補)",
      "pageTitle": "技能交換市集",
      "introContent": "一場護法會空前的交流平台，五大學習路線，二十八個智慧小島，淬鍊最精華的實務經驗。藉由相互觀摩，見賢思齊，以期護法技能，全面升級！",
      "cardDesc": "一場護法會空前的交流平台，五大學習路線，二十八個智慧小島，淬鍊最精華的實務經驗。藉由相互觀摩，見賢思齊，以期護法技能，全面升級！",
      "scheduleTitleBlack": "護法技能交換市集",
      "scheduleTitleRed": "場次表",
      "scheduleColumnSession": "場次",
      "scheduleColumnTime": "時間",
      "stampRallyTitleBlack": "集章",
      "stampRallyTitleRed": "活動辦法",
      "conditionsLabel": "兌換條件：",
      "redeemTimeLabel": "兌換時間：",
      "fastPassLabel": "FAST PASS 學習路線：",
      "mapTitleBlack": "市集",
      "mapTitleRed": "地圖",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    },
    "challenge": {
      "title": "挑戰賽",
      "subtitle": "(副標題，待補)",
      "pageTitle": "挑戰賽展區",
      "introContent": "照遍客塵光自現，機智動員菩薩行。\n這是一場由各精舍「照客組」與「機動組」攜手展現的實務創意競賽。勝負僅是一時的精進助緣，相同的是我們護法護教的願心，永不退轉！",
      "cardDesc": "照遍客塵光自現，機智動員菩薩行。 這是一場由各精舍「照客組」與「機動組」攜手展現的實務創意競賽。勝負僅是一時的精進助緣，相同的是我們護法護教的願心，永不退轉！",
      "scheduleTitleBlack": "挑戰賽",
      "scheduleTitleRed": "賽程表",
      "awardTitleRed":"總排名",
      "scheduleColumnArrival": "到場時間",
      "scheduleColumnMatch": "比賽時間",
      "scheduleColumnDeparture": "離場時間",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    }
  },
  "transmission-detail": {
    "notFound": "找不到此精舍的心傳內容",
    "backToList": "返回列表",
    "backAria": "返回",
    "likeAria": "按讚",
    "likeFailed": "按讚失敗，請稍後再試",
    "locateAria": "在地圖上查看位置",
    "locateNotFound": "找不到此精舍在地圖上的位置",
    "locateFailed": "查詢地圖位置失敗，請稍後再試",
    "noContent": "沒有內容",
  },
  "exhibition-map": {
    "closeAria": "關閉",
    "fullscreenAria": "全螢幕檢視",
    "comingSoon": {
      "title": "敬請期待",
      "desc": "此展區將於 {{date}} 開放，敬請期待！",
      "descNoDate": "此展區尚未開放，敬請期待！"
    },
    "entrance": {
      "title": "入口",
      "shortTitle": "入口",
      "subtitle": "",
      "desc": "（內容待補）"
    },
    "zone1": {
      "title": "展區一・溯源・啟航",
      "shortTitle": "展區一",
      "subtitle": "",
      "desc": "（內容待補）"
    },
    "zone2": {
      "title": "展區二・弘法・現況",
      "shortTitle": "展區二",
      "subtitle": "",
      "desc": "（內容待補）"
    },
    "zone3": {
      "title": "展區三・轉折・挑戰",
      "shortTitle": "展區三",
      "subtitle": "",
      "desc": "（內容待補）"
    },
    "zone4": {
      "title": "展區四・傳承・未來",
      "shortTitle": "展區四",
      "subtitle": "",
      "desc": "（內容待補）"
    }
  },
  "postcard-view": {
    "blessingFrom": "來自 {{name}} 的祝福",
    "sentTo": "送給 {{name}}",
    "loading": "載入明信片中…",
    "loadErrorTitle": "載入失敗",
    "loadErrorDesc": "網路或伺服器發生問題，請稍後再試",
    "reload": "重新載入",
    "notFoundTitle": "找不到這張明信片",
    "notFoundDesc": "連結可能已失效或輸入錯誤",
    "close": "關閉",
    "share": "分享",
    "done": "完成",
    "wantToSend": "也想送出祝福嗎？",
    "makePostcardHint": "為親友製作一張專屬的 35 週年祝福明信片",
    "makePostcard": "製作明信片",
    "sharePopupTitle": "分享這張明信片",
    "copyLinkLabel": "複製連結",
    "copy": "複製",
    "copied": "已複製",
    "copyFailed": "自動複製失敗，請長按上方連結手動複製"
  },
  "latest-news": {
    "backAria": "返回上一頁",
    "noContent": "此篇最新消息暫無內容"
  },
  "blessing-result": {
    "label": "開山祖師甘露法語",
    "offering": "點供",
    "completeBtn": "點燈完成",
    "downloadBtn": "下載",
    "generatingImage": "產生圖片中",
    "closeAria": "關閉",
    "resultAria": "祈福結果"
  },
  "line-browser": {
    "closeAria": "關閉",
    "notice": "目前為LINE內建瀏覽器，請使用預設瀏覽器開啟，避免資料消失和功能不正常！",
    "openInBrowser": "在預設瀏覽器中開啟"
  },
  "live-badge": {
    "live": "上線中",
    "settled": "已結算",
    "ended": "已結束",
    "upcoming": "即將開始"
  },
  "commenter-name": {
    "prefix": "以",
    "suffix": "留言",
    "hint": "（點選「姓名」可切換格式）"
  },
  "error-page": {
    "notFoundTitle": "找不到此頁面",
    "errorTitle": "頁面發生錯誤",
    "notFoundDesc": "您所尋找的頁面不存在或已移除",
    "errorDesc": "系統遇到了一些問題，請稍後再試",
    "devDetails": "錯誤詳情（僅開發環境顯示）",
    "backHome": "回首頁"
  },
  "maintenance": {
    "title": "系統維護中",
    "desc": "網站目前正在進行維護作業"
  },
  "vow-list": {
    "noValue": "無",
    "pointSupply": "點供",
    "searchAria": "搜尋",
    "closeAria": "關閉",
    "header": "祈福點燈 /",
    "totalRecords": "共 {{count}} 筆紀錄",
    "noResultsKeyword": "找不到「{{keyword}}」的結果",
    "noRecords": "尚無祈福紀錄"
  },
  "postcard-list": {
    "viewed": "已開啟",
    "notViewed": "未開啟",
    "noPoints": "無紀錄",
    "searchPlaceholder": "搜尋關鍵字",
    "searchAria": "搜尋",
    "filterAll": "所有分享",
    "filterViewed": "已開啟",
    "filterNotViewed": "未開啟",
    "filterAllCards": "所有明信片",
    "header": "寄送明信片紀錄",
    "closeAria": "關閉",
    "totalRecords": "共 {{count}} 筆紀錄",
    "totalPoints": "積分: +{{points}}",
    "noResults": "找不到結果",
    "noRecords": "尚無寄送紀錄"
  },
  "wish-tree-list": {
    "header": "至心發願紀錄",
    "closeAria": "關閉",
    "totalRecords": "共 {{count}} 筆紀錄",
    "totalPoints": "積分: +{{points}}",
    "noRecords": "尚無發願紀錄"
  },
  "wish-tree-page": {
    "title": "願心樹",
    "description": "謂發誓願，要制其心，凡所修行，期證道果。\n若不要心，或恐退失，所謂若不發心，萬事不成。\n是故諸佛菩薩，莫不發諸誓願而成正覺，是為發願。",
    "totalCount": "現在發願總數：",
    "makeVow": "我要發願",
    "treeAlt": "發願樹",
    "formTitle": "至心發願",
    "closeAria": "關閉",
    "vowerLabel": "發願者",
    "yourName": "您的姓名",
    "namePlaceholder": "請輸入姓名",
    "vowerRequired": "請輸入發願者",
    "cardStyleLabel": "選擇卡片樣式",
    "wishTextLabel": "發願文字",
    "wishTextRequired": "請選擇發願文字",
    "submitting": "送出中...",
    "submit": "發願",
    "unmuteAria": "開啟音樂",
    "muteAria": "靜音"
  },
  "board-detail": {
    "loading": "載入中...",
    "closeAria": "關閉"
  }
};

export default zhTW;
